/**
 * V2 Mock Template Screens
 *
 * Provides fallback V2 StepNode templates when themeSettingsV2 is unavailable
 * (e.g., sandbox, E2E tests, new onboardings without theme settings).
 *
 * Uses defaultStepNodeFactory to generate one template per StepKind (13 total).
 * Results are cached after first call.
 */

import { createDefaultFlowDocument } from '@modules/themes/factories/defaultStepNodeFactory';
import type { StepNode } from '@segmently/schema-models/v2';

let _cached: StepNode[] | null = null;

/**
 * Get default V2 template screens (one per StepKind).
 * Cached after first invocation.
 *
 * @returns Array of 13 StepNode templates
 */
export function getDefaultV2TemplateScreens(): StepNode[] {
  if (_cached) return _cached;
  const flowDoc = createDefaultFlowDocument();
  _cached = Object.values(flowDoc.screens);
  return _cached;
}
